import { render, staticRenderFns } from "./form-baseinfo-application-toggle.vue?vue&type=template&id=736aa458&scoped=true"
import script from "./form-baseinfo-application-toggle.vue?vue&type=script&lang=js"
export * from "./form-baseinfo-application-toggle.vue?vue&type=script&lang=js"
import style0 from "./form-baseinfo-application-toggle.vue?vue&type=style&index=0&id=736aa458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736aa458",
  null
  
)

export default component.exports